<div class="dialogContainer">
  <forge-scaffold>
    <forge-toolbar slot="header" no-divider>
      <h1 class="forge-typography--heading4" id="dialog-title" slot="start">Filter or sort</h1>
      <forge-icon-button slot="end" aria-label="Close dialog" (click)="closeDialog()">
        <forge-icon name="close"></forge-icon>
      </forge-icon-button>
    </forge-toolbar>

    <div slot="body" id="dialog-message">
      <div style="display: flex; justify-content: space-between">
        <span slot="left">{{ appliedFilterCount }} applied</span>
        <forge-button variant="text" slot="right" type="button" aria-label="Reset All" (click)="resetAllFilters()">Reset
          All</forge-button>
      </div>
      <form [formGroup]="filterForm">
        <div>
          <div slot="header" style="display: flex; justify-content: space-between">
            <div class="mb-2">Sort By</div>
            <div style="display: flex; gap: 8px; align-items: center">
              <forge-button variant="text" type="button" aria-label="Clear"
                (click)="onClearControl(['sortBy'])">Clear</forge-button>
            </div>
          </div>

          <forge-select aria-label="Sort By" formControlName="sortBy">
            <forge-option value="recentArrestDate">Most recent arrest date</forge-option>
            <forge-option value="oldestArrestDate">Oldest arrest date</forge-option>
            <forge-option value="youngestAge">Youngest to Oldest age</forge-option>
            <forge-option value="oldestAge">Oldest to youngest age</forge-option>
          </forge-select>
        </div>
        <div class="mt-4"><forge-divider></forge-divider></div>
        <div class="mt-4">
          <div slot="header" style="display: flex; justify-content: space-between">
            <div class="mb-2">Filter by arrest date range</div>
            <div style="display: flex; gap: 8px; align-items: center">
              @if(filterForm.controls.dateRange.value) {
              <forge-button variant="text" type="button"
                (click)="onClearControl(['dateRange', 'minArrestDate', 'maxArrestDate'])" aria-label="Clear">
                Clear
              </forge-button>
              }
            </div>
          </div>

          <forge-select aria-label="Sort By Date" label="Select date range" formControlName="dateRange">
            <forge-option value="{{LastNDays.Last7Days}}">Last 7 Days</forge-option>
            <forge-option value="{{LastNDays.Last14Days}}">Last 14 Days</forge-option>
            <forge-option value="{{LastNDays.Last30Days}}">Last 30 Days</forge-option>
            <forge-option value="{{LastNDays.Custom}}">Custom Date Range</forge-option>
          </forge-select>

          <!--          eslint-disable-next-line -->
          @if(filterForm.controls.dateRange.value == LastNDays.Custom) {
          <forge-date-range-picker [min]="minDatePickerValue" class="mt-2">
            <forge-text-field>
              <label for="customDatePicker">Custom date range</label>
              <input type="text" id="customDatePicker" autocomplete="off" placeholder="mm/dd/yyyy"
                formControlName="minArrestDate" style="text-align: right" />
              <input type="text" id="input-date-range-picker-02" autocomplete="off" placeholder="mm/dd/yyyy"
                formControlName="maxArrestDate" />
            </forge-text-field>
          </forge-date-range-picker>
          }
        </div>
        <div class="mt-4"><forge-divider></forge-divider></div>
        <div class="mt-4">
          <div slot="header" style="display: flex; justify-content: space-between">
            <div class="mb-2">Filter by age range</div>
            <div style="display: flex; gap: 8px; align-items: center">
              @if(filterForm.controls.minAge.value || filterForm.controls.maxAge.value) {
              <forge-button variant="text" type="button" (click)="onClearControl(['minAge', 'maxAge'])"
                aria-label="Clear">Clear</forge-button>
              }
            </div>
          </div>
          <div class="row ageInputs">
            <div class="col-6">
              <forge-text-field>
                <label for="input-minAge">Min. age</label>
                <input id="input-minAge" type="number" formControlName="minAge" min="0" />
              </forge-text-field>
            </div>
            <div class="col-6">
              <forge-text-field>
                <label for="input-maxAge">Max. age</label>
                <input id="input-maxAge" type="number" formControlName="maxAge" min="0" />
              </forge-text-field>
            </div>
          </div>
        </div>
        <div class="mt-4"><forge-divider></forge-divider></div>
        <div class="mt-4">
          <div slot="header" style="display: flex; justify-content: space-between">
            <div class="mb-2">Filter arresting agencies</div>
            <div style="display: flex; gap: 8px; align-items: center">
              @if(filterForm.controls.arrestingAgencies.value?.length) {
              <forge-button variant="text" type="button" (click)="onClearControl(['arrestingAgencies'])"
                aria-label="Clear">Clear</forge-button>
              }
            </div>
          </div>
          <div role="group" id="content" aria-label="Content">
            <forge-select class="agencies-select" aria-label="Arresting Agencies" label="Arresting Agencies"
              formControlName="arrestingAgencies" multiple [options]="arrestingAgencies">
            </forge-select>
          </div>
        </div>
      </form>
    </div>
    <forge-toolbar slot="footer" no-divider>
      <div slot="center" class="w-100">
        <forge-button variant="raised" (click)="onSubmit()" class="w-100" aria-label="Apply">Apply</forge-button>
      </div>
    </forge-toolbar>
  </forge-scaffold>
</div>